/**
 * useSignalsClearedFlash — déclenche le flash vert « fait » de l'orbe Juliette
 * quand l'agent vient de tout traiter (compteur de signaux passé de >0 à 0) sur
 * une page proactive (CRM / Messagerie). Phase 4 (polish) du chantier présence.
 *
 * Renvoie true pendant FLASH_MS après la transition, puis false. Gardé par
 * `proactive` : quitter le CRM ne déclenche pas le flash (le compteur ne tombe
 * d'ailleurs pas à 0 — la query garde son cache —, mais on verrouille quand même).
 */

import { useEffect, useRef, useState } from "react";

const FLASH_MS = 1500;

export function useSignalsClearedFlash(count: number, proactive: boolean): boolean {
  const [flash, setFlash] = useState(false);
  const prevCount = useRef(count);

  useEffect(() => {
    const prev = prevCount.current;
    prevCount.current = count;
    if (proactive && prev > 0 && count === 0) {
      setFlash(true);
      const timer = setTimeout(() => setFlash(false), FLASH_MS);
      return () => clearTimeout(timer);
    }
    // Un nouveau signal arrive pendant le flash (count repasse > 0) : on coupe
    // immédiatement, sinon l'orbe resterait verte « Tout est traité » et
    // masquerait le lead chaud (le timer du flash a été annulé par le cleanup).
    if (count > 0) setFlash(false);
  }, [count, proactive]);

  return flash;
}
